var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2627 20.9596C23.6048 22.3877 23.2908 23.0239 22.4478 24.2865C21.2709 26.0456 19.608 28.243 17.5517 28.2592C15.7235 28.2722 15.2541 27.0875 12.7714 27.107C10.2886 27.12 9.77292 28.2819 7.94145 28.2625C5.88517 28.243 4.31156 26.2631 3.13466 24.5072C-0.161326 19.5769 -0.511751 13.7996 1.52799 10.7259C2.96937 8.54475 5.25044 7.26594 7.38936 7.26594C9.57126 7.26594 10.9399 8.44089 12.7449 8.44089C14.4937 8.44089 15.5582 7.2627 18.0807 7.2627C19.9882 7.2627 22.0081 8.28185 23.4494 10.0443C18.7319 12.5792 19.4989 19.1907 24.2627 20.9596Z",
    fill: "url(#paint0_linear_211_1748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7977 4.98369C16.7493 3.75637 17.4717 2.02696 17.2078 0.262695C15.6553 0.367296 13.839 1.36449 12.7798 2.65457C11.8177 3.82959 11.019 5.57294 11.3315 7.2605C13.0263 7.31629 14.7802 6.30166 15.7977 4.98369Z",
    fill: "url(#paint1_linear_211_1748)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_211_1748",
    x1: -2.91999,
    y1: 1.57578,
    x2: 28.4866,
    y2: 33.5648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_211_1748",
    x1: 7.38781,
    y1: -3.14828,
    x2: 20.1742,
    y2: 9.58759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.becb7ac9753be182522caf338175b069.svg";
export { ForwardRef as ReactComponent };